import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import { EditOtherContentApiRequest } from '@/data/payload/api/OtherContentRequest'
import { OtherContentPresenter } from '@/app/ui/presenters/OtherContentPresenter'
import { OtherContent } from '@/domain/entities/OtherContent'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface OtherContentState {
  OtherContentData: OtherContent
  isLoading: boolean
}

@Module({ namespaced: true, dynamic: true, store, name: 'OtherContent' })
class OtherContents extends VuexModule implements OtherContentState {
  public OtherContentData = new OtherContent(true, '')
  public isLoading = true

  @Action
  public async getOtherContentData(params: { name: string }) {
    this.setLoading(true)
    const presenter = await container.resolve(OtherContentPresenter)
    presenter
      .loadOtherContent(new Map(), params.name)
      .then(async (res: OtherContent) => {
        this.setLoading(false)
        this.setOtherContentData(res)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
  }

  @Action
  public async editOtherContentData(params: {
    name: string
    content: string
    fileUpload: any
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(OtherContentPresenter)
    presenter
      .editOtherContent(
        new EditOtherContentApiRequest(
          params.name,
          params.content,
          params.fileUpload
        )
      )
      .then((res) => {
        const name = params.name
        Vue.prototype.$notify({
          title: name,
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getOtherContentData({ name })
      })
      .catch((error) => {
        this.setLoading(false)
        console.error('error', error)
      })
  }

  @Mutation
  private setOtherContentData(otherContent: OtherContent) {
    this.OtherContentData = otherContent
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
}

export const OtherContentModule = getModule(OtherContents)
